// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"247":"ebaca91d","845":"116b9008"}[chunkId] + ".chunk.js";
};